module.exports = __webpack_public_path__ + "static/media/pic_kethmi.35385b8e.jpg";